/** Only campaign parameters belong in analytics URLs; never form/query contents. */
const CAMPAIGN_PARAMETERS = new Set([
  "utm_id",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_source_platform",
  "utm_creative_format",
  "utm_marketing_tactic",
]);

export function analyticsUrl(value: string, origin?: string): string {
  if (!value) return "";
  try {
    const url = new URL(value, origin);
    if (!["https:", "http:"].includes(url.protocol)) return "";
    url.username = "";
    url.password = "";
    url.hash = "";
    for (const key of [...url.searchParams.keys()]) {
      if (!CAMPAIGN_PARAMETERS.has(key)) url.searchParams.delete(key);
    }
    return url.toString();
  } catch {
    return "";
  }
}

export interface AnalyticsPage {
  path: string;
  location: string;
  title: string;
  referrer: string;
}
